<template>
  <div>
    <!--<tooltip label="View" type="default" placement="left">-->
      <!--<a class="button button-table is-small" @click="view()">-->
        <!--<i class="fa fa-eye"></i>-->
      <!--</a>-->
    <!--</tooltip>-->
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      view () {
        this.$router.push({name: 'Service', params: {id: this.data.id}})
      }
    }
  }
</script>

<style lang="scss">
  .button-table {
    padding-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// ExchangeTableButtons.vue?357752b2